var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99921 1C8.99921 0.447715 8.55149 0 7.99921 0C7.44692 0 6.99921 0.447715 6.99921 1V1.75H6.44179C4.21672 1.75 2.37512 3.48001 2.23622 5.70074L2.01522 9.2342C1.93096 10.5814 1.47867 11.8797 0.70761 12.9876C0.0109285 13.9886 0.631149 15.3712 1.84208 15.5165L5.24921 15.9254V17C5.24921 18.5188 6.48042 19.75 7.99921 19.75C9.51799 19.75 10.7492 18.5188 10.7492 17V15.9254L14.1563 15.5165C15.3673 15.3712 15.9875 13.9886 15.2908 12.9876C14.5197 11.8797 14.0674 10.5814 13.9832 9.2342L13.7622 5.70074C13.6233 3.48001 11.7817 1.75 9.55661 1.75H8.99921V1ZM6.74921 17C6.74921 17.6904 7.30885 18.25 7.99921 18.25C8.68956 18.25 9.24921 17.6904 9.24921 17V16.25H6.74921V17Z",
    fill: "#062744",
    fillOpacity: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.461f5a9a53bdba6b004cf7a4206ef4e0.svg";
export { ForwardRef as ReactComponent };